import Component from "@glimmer/component";
import { action } from "@ember/object";
import TEMPLATES from "./templates";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { stringable } from "glesys-controlpanel/utils/prop-types";
import { func } from "prop-types";

import Label from "glesys-controlpanel/components/label";
import Box from "glesys-controlpanel/components/box";
import Dropdown from "glesys-controlpanel/components/dropdown";
import DropdownItem from "glesys-controlpanel/components/dropdown/item";

import canManage from "glesys-controlpanel/helpers/can-manage";

import { and, eq } from "ember-truth-helpers";
import { t } from "ember-intl";
import { on } from "@ember/modifier";
import { fn } from "@ember/helper";

@forbidExtraArgs
export default class DnsGroup extends Component {
  @arg(stringable.isRequired) type;

  @arg(func.isRequired) onTemplate;

  get templates() {
    return TEMPLATES[this.type] || [];
  }

  @action
  template(template) {
    this.onTemplate(template);
  }

  get hasTemplates() {
    return Boolean(this.templates.length);
  }

  <template>
    <Box @showFooter={{and (canManage) this.hasTemplates}} ...attributes>
      <:default>
        <h3 class="flex justify-center leading-normal text-gray-800 text-xl" data-test-dns-group-type>
          {{this.type}}
        </h3>

        <table class="min-w-full text-left text-base mt-4 mb-2">
          <thead>
            <tr>
              <th><span class="sr-only">{{t "label.status"}}</span></th>
              <th>
                <Label>
                  {{t "label.host"}}
                </Label>
              </th>
              <th>
                <Label>
                  TTL
                </Label>
              </th>
              {{#if (eq this.type "MX")}}
                <th>
                  <Label>
                    {{t "label.prio"}}
                  </Label>
                </th>
              {{/if}}
              {{#if (eq this.type "SRV")}}
                <th>
                  <Label>
                    {{t "label.prio"}}
                  </Label>
                </th>
                <th>
                  <Label>
                    {{t "label.weight"}}
                  </Label>
                </th>
                <th>
                  <Label>
                    {{t "label.port"}}
                  </Label>
                </th>
                <th>
                  <Label>
                    {{t "label.target"}}
                  </Label>
                </th>
              {{else}}
                <th>
                  <Label>
                    {{t "label.data"}}
                  </Label>
                </th>
              {{/if}}
              <th><span class="sr-only">{{t "label.actions"}}</span></th>
            </tr>
          </thead>

          <tbody>
            {{yield}}
          </tbody>
        </table>
      </:default>

      <:footer>
        {{#if (and (canManage) this.hasTemplates)}}
          <Dropdown
            class="bg-white border border-gray-200 hover:border-gray-200 hover:bg-gray-50 px-4 py-2 rounded-sm text-gray-800 hover:text-gray-500 font-sans"
            data-test-dns-group-template
          >
            <:header>
              {{t "button.templates"}}
            </:header>
            <:default>
              {{#each this.templates as |template|}}
                <DropdownItem
                  data-test-dns-group-template-value={{template.label}}
                  {{on "click" (fn this.template template)}}
                >
                  {{template.label}}
                </DropdownItem>
              {{/each}}
            </:default>
          </Dropdown>
        {{/if}}
      </:footer>
    </Box>
  </template>
}
